import { createUseStyles } from 'react-jss'
import { lightGrey } from '../../../../../styles/const/colors'

const defaultAvatarSize = 32

const useStyles = createUseStyles({
  avatar: {
    width: props => props?.size || defaultAvatarSize,
    minWidth: props => props?.size || defaultAvatarSize, // minWidth need to be set as well (width is not enough) to prevent avatar from shrinking
    height: props => props?.size || defaultAvatarSize,
    borderRadius: '50%',
    backgroundColor: lightGrey,
    marginRight: 8,
    overflow: 'hidden',

    '& img': {
      maxWidth: '100%',
      maxHeight: '100%'
    }
  }
})

export default useStyles
